<template>
  <div class="Banner">
    <div :class="{
      'bg-tertiary-300 text-tertiary-800 dark:bg-tertiary-800 dark:text-white':
        style == 'success',
      'bg-secondary-200 text-primary-dark': style == 'danger',
      'bg-warning-200 text-warning-dark': style == 'warning',
      'bg-info-700 text-info-100': style == 'info',
    }" v-if="show && message">
      <div class="container py-2">
        <div class="flex items-center justify-between flex-wrap">
          <div class="w-0 flex-1 flex items-center min-w-0">
            <span class="flex rounded-lg">
              <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" v-if="style == 'success'">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>

              <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" v-if="style == 'danger'">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>

              <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" v-if="style == 'warning'">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>

              <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" v-if="style == 'info'">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z">
                </path>
              </svg>
            </span>

            <p class="ml-3 font-bold text-sm" v-html="message"></p>
          </div>

          <div class="shrink-0 sm:ml-3">
            <button type="button"
              class="-mr-1 flex p-2 rounded-md focus:outline-none sm:-mr-2 transition ease-in-out duration-150" :class="{
                'hover:bg-tertiary-100 focus:bg-tertiary-100 dark:hover:bg-tertiary-900 dark:focus:bg-tertiary-900':
                  style == 'success',
                'hover:bg-secondary-100 focus:bg-secondary-100': style == 'danger',
                'hover:bg-warning-100 focus:bg-warning-100': style == 'warning',
                'hover:bg-info-dark focus:bg-info-dark': style == 'info',
              }" aria-label="Dismiss" @click.prevent="show = false">
              <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatLocalFromUTC } from '@/Utils/date';
import { DateTime } from 'luxon';
import humanize from 'humanize-duration';
import matchAll from 'string.prototype.matchall';

export default {
  data() {
    return {
      show: true,
    };
  },

  computed: {
    style() {
      return this.$page.props.jetstream?.flash?.bannerStyle || 'success';
    },

    message() {
      let banner = this.$page.props.jetstream?.flash?.banner || '';

      if (banner && banner.indexOf('formatLocalFromUTC') !== -1) {
        let dateRegex = /(.*)formatLocalFromUTC\:\:(\S*)\:\:(.*)/g;
        let [dateMatches] = [...matchAll(banner, dateRegex)];
        banner = `${dateMatches[1]}${formatLocalFromUTC(dateMatches[2])}${dateMatches[3]}`;
      }

      if (banner && banner.indexOf('humanizeDiff') !== -1) {
        let humRegex = /(.*)humanizeDiff\:\:(\S*)\:\:(.*)/g;
        let [humMatches] = [...matchAll(banner, humRegex)];
        let humDiff = DateTime.fromISO(humMatches[2]).toMillis() - new Date().getTime();
        let humStr = humanize(humDiff, { largest: 1, round: true });
        banner = `${humMatches[1]}${humStr}${humMatches[3]}`;
      }
      return banner.replace('for 0 seconds (Invalid DateTime)', '');
    },
  },
};
</script>
